// removed by extract-text-webpack-plugin
module.exports = {"table":"RH70HZWrFF8bVmBbO4yeC","open":"_2oPtU0b5mSZ1h6iSpW5yoC","cell":"_278ceQzNEAEvm7SbZbMTok","body":"_2ecSctCgCmyxKC4x55rlNy","close":"_3FcLQHL1b2A6KRJc6TovDY"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/modal.css
// module id = 169
// module chunks = 0